import { type ReactNode } from 'react'

import { useFirstStepHeight } from '../../../../hooks/use-first-step-height'
import sharedStyles from '../../../choose-frequency-later-lock/choose-frequency-later-lock.module.scss'
import { useChooseOfferFrequencyLaterContext } from '../../context-provider'
import { ChooseFrequencyLaterModalSteps } from '../../types'

interface StepContentWrapperProps {
  children: ReactNode
}

export function StepContentWrapper({ children }: StepContentWrapperProps) {
  const { currentStep } = useChooseOfferFrequencyLaterContext()
  const isSecondStep = currentStep === ChooseFrequencyLaterModalSteps.SELECT_FREQUENCY
  const { contentRef, firstStepHeight } = useFirstStepHeight(isSecondStep)

  const wrapperClassName = isSecondStep ? sharedStyles.secondStepWrapper : undefined
  const secondStepStyle = isSecondStep
    ? ({ '--first-step-height': `${firstStepHeight}px` } as React.CSSProperties)
    : undefined

  return (
    <div ref={contentRef} className={wrapperClassName} style={secondStepStyle}>
      {children}
    </div>
  )
}
